import { FC, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';

import { Card, Headline, Icon, Layout, Page, Stack } from '@servicetitan/design-system';
import { provide, useDependencies } from '@servicetitan/react-ioc';

import { environment } from '../../api';
import { PageSpinner } from '../../common';
import { HomePageStore } from '../stores/home-page.store';

import '../assets/home-page.css';

export const HomePage: FC = provide({ singletons: [HomePageStore] })(
    observer(() => {
        const [store] = useDependencies(HomePageStore);
        const history = useHistory();

        useEffect(() => {
            store.load();
        }, [store]);

        const goToAppsPage = useCallback(() => {
            history.push('/apps');
        }, [history]);

        const goToClientsPage = useCallback(() => {
            const apiGroup = store.firstResourceOwnerApiGroup!;
            history.push(`/clients/${apiGroup.name}/${apiGroup.assignedResourceOwners[0]}`);
        }, [store, history]);

        if (store.loading) {
            return <PageSpinner />;
        }

        return (
            <Page header={<Headline size="large">{environment.site.title}</Headline>}>
                <Layout type="island">
                    <Card elevation="raised" onClick={goToAppsPage}>
                        <Stack direction="row" alignItems="center" spacing={3}>
                            <Stack.Item className="icon-container icon-container-apps">
                                <Icon name="apps" />
                            </Stack.Item>
                            <Stack.Item fill>
                                <Headline>Register and Manage Applications</Headline>
                            </Stack.Item>
                            <Stack.Item>
                                <Icon name="keyboard_arrow_right" size={48} />
                            </Stack.Item>
                        </Stack>
                    </Card>
                    {store.firstResourceOwnerApiGroup && (
                        <Card elevation="raised" onClick={goToClientsPage}>
                            <Stack direction="row" alignItems="center" spacing={3}>
                                <Stack.Item className="icon-container icon-container-clients">
                                    <Icon name="apps" />
                                </Stack.Item>
                                <Stack.Item fill>
                                    <Headline>Manage Integrations and API Access</Headline>
                                </Stack.Item>
                                <Stack.Item>
                                    <Icon name="keyboard_arrow_right" size={48} />
                                </Stack.Item>
                            </Stack>
                        </Card>
                    )}
                </Layout>
            </Page>
        );
    }),
);
HomePage.displayName = 'HomePage';
